"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var constants_1 = require("../data/constants");
var message = function (data) {
    return Request.sendPost(constants_1.endpoints.api + "/supports", data);
};
exports.message = message;
//# sourceMappingURL=support.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/support.js
// module id = 912
// module chunks = 3